import { ACCOUNT_CREDIT_TITLE } from '@/utils/constants'

const PAGE_TITLES: { [key: string]: string } = {
  'tickets.home': 'Purchase Tickets',
  'orders.new': 'Purchase Tickets',
  'orders.confirmation': 'Order Confirmation',
  'reservations.confirmation': 'Order Confirmation',
  reservations: 'Reservations',
  orders: 'My Orders',
  'my-account': 'My Account',
  security: 'Password & Security',
  signIn: 'Sign In',
  signUp: 'Sign Up',
  'reset-password': 'Reset Password',
  'send-reset-password-instructions': 'Reset Password',
  'payment-methods': 'Payment Methods',
  'trip-cards': 'Trip Cards',
  'trip-card-balance-history': 'Trip Card Balance',
  'trip-card-top-up-history': 'Trip Card Top-ups',
  'account-credit': ACCOUNT_CREDIT_TITLE
}

export function getTitle(page: string): string {
  if (PAGE_TITLES[page]) {
    return `${PAGE_TITLES[page]} | Seastreak`
  } else {
    return 'Seastreak'
  }
}

export default {
  getTitle
}
